import { Controller } from "@hotwired/stimulus"

// Retain a native form select as the no-JavaScript fallback and submitted value.
export default class extends Controller {
    static targets = ["select", "enhanced", "trigger", "icon", "label", "option"]

    connect() {
        this.selectTarget.hidden = true
        this.enhancedTarget.hidden = false
        this.sync()
    }

    disconnect() {
        this.selectTarget.hidden = false
        this.enhancedTarget.hidden = true
    }

    get menu() {
        return this.application.getControllerForElementAndIdentifier(this.element, "split-menu")
    }

    sync() {
        const selected = this.optionTargets.find(option => option.dataset.value === this.selectTarget.value)
        if (!selected) return
        this.iconTarget.className = `bi ${selected.dataset.icon} profile-link-audience-icon--${selected.dataset.modifier}`
        this.labelTarget.textContent = selected.dataset.label
        this.optionTargets.forEach(option => option.setAttribute("aria-checked", String(option === selected)))
    }

    toggle(event) {
        this.menu.toggle(event)
        if (this.triggerTarget.getAttribute("aria-expanded") === "true") this.selectedOption.focus()
    }

    get selectedOption() {
        return this.optionTargets.find(option => option.getAttribute("aria-checked") === "true") || this.optionTargets[0]
    }

    choose(event) {
        this.selectTarget.value = event.currentTarget.dataset.value
        this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
        this.menu.close()
        this.triggerTarget.focus()
    }

    keydown(event) {
        if (event.key === "Tab") {
            this.menu.close()
            this.triggerTarget.focus()
            return
        }
        if (event.key === "Escape") {
            event.preventDefault()
            this.menu.close()
            this.triggerTarget.focus()
            return
        }
        if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) return
        event.preventDefault()
        const wasOpen = this.triggerTarget.getAttribute("aria-expanded") === "true"
        if (!wasOpen) {
            this.menu.open()
            this.selectedOption.focus()
            return
        }
        const index = this.optionTargets.indexOf(document.activeElement)
        const next = event.key === "Home" ? 0 : event.key === "End" ? this.optionTargets.length - 1
            : (index + (event.key === "ArrowDown" ? 1 : -1) + this.optionTargets.length) % this.optionTargets.length
        this.optionTargets[next].focus()
    }
}
